module.exports = __webpack_public_path__ + "img/image012.a178e365.png";